package com.icebyte.printprofiletracker

import androidx.compose.runtime.Composable
import androidx.compose.ui.tooling.preview.Preview

@Composable
@Preview
fun App() {
    ProfileDashboardScreen()
}
